import SelectAll from './component';
import styled from 'styled-components';

export default styled(SelectAll)`
  display: flex;
  font-weight: normal;
  cursor: pointer;

  label {
    margin-right: 7px;

    span:first-child {
      margin: 0 0 6px 0;
      min-width: 16px;
      max-width: 16px;
      max-height: 16px;

      svg {
        width: 12px;
        height: 12px;
      }
    }
  }

  .text {
    margin-right: 8px;
  }
`;
